import React from 'react';
import { Otto } from './otto';

// Dashboard 100% empty state. Rendered above the panels (At Risk,
// Briefs Due, My Notes) when the supplier-state, brief, and
// compliance conditions all read zero. Sits between the greeting +
// KPI row and the rest of the dashboard. KPIs still show (all zero);
// the panels still show with their own existing TurboIdle empties.
//
// Trigger conditions live in Dashboard.js — this component is purely
// presentational, takes no props, and exists when its parent decides
// to render it.
export default function InboxZeroCard() {
  return (
    <div className="bg-white border border-line rounded-xl px-8 py-10 mb-6 text-center">
      <div className="flex justify-center mb-5">
        <Otto pose="sleeping" size={132} ariaLabel="Otto — all caught up" />
      </div>
      <div className="font-['Metropolis'] text-[11px] font-extrabold uppercase tracking-[0.25em] text-fusion-forest mb-3">
        Inbox Zero
      </div>
      <h2 className="font-['Metropolis'] text-[24px] sm:text-[28px] font-extrabold text-ink tracking-[0.02em] mb-2.5">
        Nothing to see here.
      </h2>
      <p className="font-['Metropolis'] text-sm text-fusion-mid-grey leading-relaxed max-w-[420px] mx-auto">
        All briefs are accounted for, all compliance is current, all suppliers are settled. Good work.
      </p>
    </div>
  );
}
